import React from "react";
// import bgImage from "../Assets/welcome2.png"
import { Base64 } from "js-base64";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import './thanksPage.scss'
import success from "../assets/images/subscription_activated_icon.png";
import low_bal from "../assets/images/low_balance_icon.png";
import error from "../assets/images/technical_error_icon.png";
import failed from "../assets/images/subscription_failure_icon.png"

const ThanksPage = ({ homeLogo }) => {
    const { search } = useLocation();
    let { msg, reason, msgs } = queryString.parse(search);
    msg = msg && Base64.decode(msg);
    const decodedMessages = msgs ? msgs.split(',').map(msg => Base64.decode(msg)) : [];
    const [message, message1, message2, message3] = decodedMessages;
    const status = localStorage.getItem("subStatus") 
    const checkStatus =  localStorage.getItem("checkStatus");

    return (
        <div className="m-w px-7 py-1 my-10"
        >
            <div className="columns is-mobile">
                <div className="column is-full">
                    {homeLogo && <img src={homeLogo} alt="logo" className="my-3" height="80px" width="80px" />}
                  <div>
                  <img
                        src={status === 'ACTIVE' ? success : status === 'INACTIVE' ? low_bal : (checkStatus === 'FAILED' && status == 'undefined') ? failed : error}
                        alt="success"
                        className="status-img"
                        style={{ }}
                    />
                  </div>
                    <div className="my-10">
                        {msg && <div className="text-white text-center font-bold text-lg">{msg}</div>}
                        {message && <div className="text-white text-center font-bold text-xl">{message}</div>}
                        {/* {btnText && <button onClick={() => { handleClick() }} className="buttoncls-double-confirm my-12">{btnText}</button>} */}
                        {message1 && <div className={`text-white text-center font-bold text-lg my-1`}>{message1}</div>}
                        {message2 && <div className="text-white text-center font-bold text-lg">{message2}</div>}
                        {message3 && <div className="text-white text-center font-bold text-lg">{message3}</div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ThanksPage 